module.exports = __webpack_public_path__ + "static/img/record.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/record.png
// module id = xHHx
// module chunks = 0